import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-quota",
  "use": "app-icon-quota-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-quota\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M7.5 1.5v7h7a7 7 0 11-7.24-6.996L7.5 1.5zM6 3.207A5.5 5.5 0 1012.793 10H6V3.207zM8.5.5a7 7 0 016.996 6.76l.004.24-.75-.001V7.5H8.5v-7zM10 2.207V6h3.793A5.511 5.511 0 0010 2.208z\" fill=\"#6C7280\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol